import React from 'react'
import { Route, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Default from '../../layouts/default'

const SignIn = ({ location: from }) => (
  <Redirect to={{ pathname: '/users/sign_in', state: { from } }} />
)

const render = (Component, Layout = Default, user_signed_in) => props =>
  user_signed_in ? (
    <Layout {...props}>
      <Component />
    </Layout>
  ) : (
    <SignIn {...props} />
  )

const Private = ({ component, layout, user_signed_in, ...rest }) => (
  <Route {...rest} render={render(component, layout, user_signed_in)} />
)

const mapStateToProps = state => ({
  user_signed_in: !!state.users.authorization
})

export default withRouter(connect(mapStateToProps)(Private))



// WEBPACK FOOTER //
// ./src/containers/routes/private/index.js